import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconRecurring: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 7V8.25H2V7C2 5 3 4 5 4H17C19 4 20 5 20 7ZM20 9.75V10.98C20 11.19 19.8 11.32 19.6 11.26C18.47 10.89 17.15 10.88 15.86 11.47C14.83 11.94 13.98 12.78 13.49 13.81C12.88 15.12 12.88 16.46 13.26 17.6C13.32 17.8 13.19 18 12.98 18H5C3 18 2 17 2 15V9.75H20ZM9.75 14C9.75 13.586 9.414 13.25 9 13.25H6C5.586 13.25 5.25 13.586 5.25 14C5.25 14.414 5.586 14.75 6 14.75H9C9.414 14.75 9.75 14.414 9.75 14ZM22 18.25H17.5C17.086 18.25 16.75 17.914 16.75 17.5V17C16.75 16.586 16.414 16.25 16 16.25C15.586 16.25 15.25 16.586 15.25 17V17.5C15.25 18.741 16.259 19.75 17.5 19.75H20.292C20.199 20.014 20.258 20.319 20.469 20.53C20.615 20.676 20.807 20.75 20.999 20.75C21.191 20.75 21.383 20.677 21.529 20.53L22.529 19.53C22.743 19.316 22.808 18.993 22.692 18.713C22.576 18.433 22.303 18.25 22 18.25ZM20.5 13.75H17.708C17.801 13.486 17.742 13.181 17.531 12.97C17.238 12.677 16.763 12.677 16.47 12.97L15.47 13.97C15.256 14.184 15.191 14.507 15.307 14.787C15.423 15.067 15.697 15.25 16 15.25H20.5C20.914 15.25 21.25 15.586 21.25 16V16.5C21.25 16.914 21.586 17.25 22 17.25C22.414 17.25 22.75 16.914 22.75 16.5V16C22.75 14.759 21.741 13.75 20.5 13.75Z"
      fill={color}
    />
  </svg>
);

export default IconRecurring;
